import { Fade } from '@mui/material';
import type { variables } from '../mpanels/variables';

type Variables = typeof variables;

const createMuiPopoverStyles = (variables: Variables) => ({
    defaultProps: {
        TransitionComponent: Fade,
    },
    styleOverrides: {
        paper: {
            boxShadow: variables.boxShadows.popoverShadow,
        },
    },
});

export default createMuiPopoverStyles;
